<template>
    <div id="Header" class="sticky-top">
        <div id="HeaderNotice" :class="['alert py-2 mb-0 rounded-0 bg-black', { 'd-none' : hideHeaderNotice }]">
            <div class="container d-flex">
                <p class="text-white mb-0 flex-grow-1 text-center">
                    Get FREE 18-month tyre insurance on all Dunlop passenger, SUV, 4x4, and light truck tyres. <a href="/dunlop-sure" target="_blank" class="text-white"><u>More info</u></a>
                </p>
                <a href="#" data-dismiss="alert" aria-label="close" title="close" @click="closeHeaderNotice" class="close text-decoration-none text-white">&times;</a>
            </div>
        </div>

        <nav class="navbar navbar-expand-lg">
            <div class="container">
                <a target="_top" class="navbar-brand" href="/"><img id="dunlop-logo" alt="Dunlop Tyres South Africa" title="Dunlop Tyres" class="logo" src="data:image/png;base64,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"></a>
                <button type="button" class="navbar-toggler collapsed" data-toggle="collapse" data-target="#Navbar" aria-controls="Navbar" aria-expanded="false" aria-label="Toggle navigation">
                    <div class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>

                <div class="collapse navbar-collapse" id="Navbar">
                    <ul class="navbar-nav desktop-nav ml-auto navbar-nav-scroll d-none d-lg-flex">
                        <li :class="['nav-item', {
                                'dropdown' : (navItem.menuItemsList && navItem.menuItemsList.menuItems.length)
                            }]" v-for="navItem in menuList" :key="navItem.displayText">

                            <a target="_top" v-if="!navItem.menuItemsList || navItem.menuItemsList.menuItems.length < 1" :href="navItem.linkMenuItem.url"
                               class="nav-link text-black" @click="isDealerLocator(navItem.linkMenuItem.url) ? logDealerLocatorClick($event.target) : null">
                                {{getDisplayText(navItem.linkMenuItem.url, navItem.displayText)}}
                            </a>

                            <template v-if="navItem.menuItemsList && navItem.menuItemsList.menuItems.length">
                                <a target="_top" href="#"
                                   class="nav-link dropdown-toggle text-black" role="button"
                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{navItem.displayText}}
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbar-menu">
                                    <a target="_top" class="dropdown-item text-white"
                                       v-for="dropdownItem in navItem.menuItemsList.menuItems" :key="dropdownItem.displayText" :href="dropdownItem.linkMenuItem.url">
                                        {{dropdownItem.displayText}}
                                    </a>
                                </div>
                            </template>
                        </li>

                        <li class="nav-item click-2-fit">
                            <a target="_top" class="nav-link py-1 pr-0" href="/click-2-fit"><img src="../../../assets/images/click2fit.svg" alt="" /></a>
                        </li>
                    </ul>
                    <div class="navbar-nav mobile-nav ml-auto navbar-nav-scroll d-lg-none">
                        <div :key="`mobile-${navItem.displayText}`" :class="['nav-item', {
                                'dropdown' : (navItem.menuItemsList && navItem.menuItemsList.menuItems.length)
                            }]" v-for="navItem in mobileNav">

                            <a target="_top" v-if="!navItem.menuItemsList || navItem.menuItemsList.menuItems.length < 1" :href="navItem.linkMenuItem.url"
                               class="nav-link text-black">
                                {{getDisplayText(navItem.linkMenuItem.url, navItem.displayText)}}
                            </a>

                            <template v-if="navItem.menuItemsList && navItem.menuItemsList.menuItems.length">
                                <a target="_top" href="#"
                                   class="nav-link dropdown-toggle text-black" role="button"
                                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {{navItem.displayText}}
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbar-menu">
                                    <a target="_top" class="dropdown-item text-white"
                                       v-for="dropdownItem in navItem.menuItemsList.menuItems" :key="dropdownItem.displayText" :href="dropdownItem.linkMenuItem.url">
                                        {{dropdownItem.displayText}}
                                    </a>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    import gql from 'graphql-tag';

    export default {
        data() {
            return {
                hideHeaderNotice: true,
                menuList: [],
                mobileNav: [],
                dealerLocatorDisplayNames: ["Find A Store"],
            };
        },
        computed: {
            getMenu() {
                return this.menu[0].menuItemsList;
            },
        },
        watch: {
            menu: {
                handler() {
                    const menuObj = this.getMenu;
                    this.menuList = menuObj.menuItems.filter((m) => m.displayText != "Mobile");
                    this.mobileNav = menuObj.menuItems.filter((m) => m.displayText == "Mobile")[0].menuItemsList.menuItems;
                }
            }
        },
        mounted() {
            if (sessionStorage.getItem('CloseHeaderNotice') != "true") {
                this.hideHeaderNotice = false;
            }
        },
        methods: {
            closeHeaderNotice(event) {
                event.preventDefault();
                this.hideHeaderNotice = true;
                sessionStorage.setItem('CloseHeaderNotice', "true");
            },
            isCookieActive(cname) {
                return document.cookie.indexOf(cname) >= 0;
            },
            getCookieValue(cname) {
                var cookieValue = false;
                if (document.cookie.split(cname).length > 1) {
                    cookieValue = document.cookie.split(cname).pop().split(";").shift();
                }
                return cookieValue;
            },
            setCookie(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + "; " + expires;
            },
            clearCookie(cname) {
                document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
            },
            isDealerLocator(url) {
                return url.indexOf("dealer-locator") > -1;
            },
            logDealerLocatorClick(e) {
                top.dataLayer = top.dataLayer || [];
                top.dataLayer.push({ 'event': 'DealerLocatorClick', 'linkText': e.innerHTML.trim() });
            },
            getDisplayText(url, defaultText) {
                return !this.isDealerLocator(url) ? defaultText : this.setDealerLocatorDisplayText();
            },
            setDealerLocatorDisplayText() {
                var dealerLocatorCookie = this.getCookieValue("dealer_locator_link=");
                var displayText = "";

                if (!dealerLocatorCookie) {
                    var randomSelect = Math.floor(Math.random() * this.dealerLocatorDisplayNames.length);
                    displayText = this.dealerLocatorDisplayNames[randomSelect];
                    this.setCookie('dealer_locator_link', displayText, 1);
                    top.dataLayer.push({ 'event': 'DealerLocatorLoad', 'linkText': displayText });
                }
                else {
                    displayText = this.getCookieValue("dealer_locator_link=");
                }
                return displayText;
            }
        },
        apollo: {
            menu: {
                query: gql`
                    {
                      menu(where: {displayText: "Navigation"}) {
                        menuItemsList {
                          menuItems {
                            ... on LinkMenuItem {
                              linkMenuItem {
                                url
                              }
                              displayText
                            }
                            menuItemsList {
                              menuItems {
                                ... on LinkMenuItem {
                                  linkMenuItem {
                                    url
                                  }
                                  displayText
                                  menuItemsList {
                                    menuItems {
                                      ... on LinkMenuItem {
                                        displayText
                                        linkMenuItem {
                                          url
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                `,
            }
        },
    };
</script>